module.exports = __webpack_public_path__ + "img/folder-blank.90246893.svg";